import AboveHeaderNav from "./Horizontal/AboveHeaderNav";
import BelowHeaderNav from "./Horizontal/BelowHeaderNav";
import InsideHeaderNav from "./Horizontal/InsideHeaderNav";
import Vertical from "./Vertical/index";

const AppLayouts = {
	Vertical,
	InsideHeaderNav,
	BelowHeaderNav,
	AboveHeaderNav,
};
export default AppLayouts;
